import { useState, useEffect } from "react";
import "./App.css";
import { NavBar } from "./Components/NavBar";
import { Hero } from "./Components/Hero";
import { About } from "./Components/About";
import { Experience } from "./Components/Experience";
import { Projects } from "./Components/Projects";
import { Contact } from "./Components/Contact";
import { CursorGlow } from "./Components/CursorGlow";
import { ScrollProgress } from "./Components/ScrollProgress";

function App() {
  const [theme, setTheme] = useState("dark");

  useEffect(() => {
    const saved = localStorage.getItem("theme") || "dark";
    setTheme(saved);
    document.documentElement.setAttribute("data-theme", saved);
  }, []);

  const toggleTheme = () => {
    const next = theme === "dark" ? "light" : "dark";
    setTheme(next);
    document.documentElement.setAttribute("data-theme", next);
    localStorage.setItem("theme", next);
  };

  return (
    <>
      <CursorGlow />
      <ScrollProgress />
      <NavBar theme={theme} toggleTheme={toggleTheme} />
      <main>
        <Hero />
        <About />
        <Experience />
        <Projects />
        <Contact />
      </main>
    </>
  );
}

export default App;
